import styled from 'styled-components';

export const AppLoadingStyled = styled.div`
	z-index: 3000;
`;

export const AppLoadingCircleStyled = styled.circle`
	z-index: 3000;
  stroke: ${(props) => props.theme.colors.colorCircle} !important;
`;